<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Login</h4>
                  <p>Please log in to your account</p>
                </div>

                <div>
                  <vs-input
                          name="username"
                          type="text"
                          icon-no-border
                          icon="icon-user"
                          icon-pack="feather"
                          label-placeholder="Username"
                          v-model="username"
                          @keyup.enter="login"
                          class="w-full"/>

                  <vs-input
                          type="password"
                          name="password"
                          icon-no-border
                          icon="icon icon-lock"
                          icon-pack="feather"
                          label-placeholder="Password"
                          v-model="password"
                          @keyup.enter="login"
                          class="w-full mt-6" />

                  <div class="flex flex-wrap justify-between my-5">
                    <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Remember me</vs-checkbox>
                  </div>
                  <vs-button @click="login" >Login</vs-button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
  export default{
    data() {
      return {
        username: "",
        password: "",
        checkbox_remember_me: false,
      }
    },
    methods: {
      login() {
        this.$vs.loading();
        const thisIns = this;
        this.$http.post('/api/reseller/v1/login/', {
          username: thisIns.username,
          password: thisIns.password,
          remember_me: thisIns.checkbox_remember_me
        }).then(function (response) {
          thisIns.$store.dispatch('setLoginStatus', true);
          thisIns.$store.dispatch('updateUserData', response.data);
          localStorage.setItem('userData', JSON.stringify(response.data));
          thisIns.$vs.loading.close();
          thisIns.$router.push("/");
        }).catch(function () {
          thisIns.$vs.loading.close();
          thisIns.$printError("Login failed");
        });
      }
    }
  }
</script>

<style lang="scss">
</style>
